import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Container, Form } from 'react-bootstrap';
import {
	deleteUser,
	getUsers,
	makeUserAdmin,
	resetPassword,
} from '../../services/userService';
import AdminLayout from './AdminLayout';

const AdminUser = () => {
	const [users, setUsers] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');

	useEffect(() => {
		fetchUsers();
	}, []);

	const fetchUsers = async () => {
		try {
			const res = await getUsers();
			setUsers(res.data);
		} catch (error) {
			console.error('Failed to fetch users', error);
		}
	};

	const handleDeleteUser = async (userId) => {
		try {
			await deleteUser(userId);
			fetchUsers();
		} catch (error) {
			console.error('Failed to delete user', error);
		}
	};

	const handleResetPassword = async (userId) => {
		try {
			await resetPassword(userId);
			alert('Password reset successfully');
		} catch (error) {
			alert('Failed to reset password');
		}
	};

	const handleMakeAdmin = async (userId) => {
		try {
			await makeUserAdmin(userId);
			fetchUsers();
		} catch (error) {
			alert('Failed to make user admin');
		}
	};

	const normalizedSearch = searchTerm.trim().toLowerCase();
	const filteredUsers = users.filter((user) => {
		if (!normalizedSearch) return true;
		const username = (user?.username || '').toLowerCase();
		const email = (user?.email || '').toLowerCase();
		return (
			username.includes(normalizedSearch) || email.includes(normalizedSearch)
		);
	});

	return (
		<AdminLayout>
			<Container>
				<Card>
					<Card.Body>
						<Card.Title>Users</Card.Title>
						<Form.Group className='mb-3'>
							<Form.Control
								type='text'
								placeholder='Search by username or email'
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</Form.Group>

						<Table striped bordered hover>
							<thead>
								<tr>
									<th>ID</th>
									<th>Username</th>
									<th>Email</th>
									<th>Role</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{filteredUsers.map((user) => (
									<tr key={user._id}>
										<td>{user._id}</td>
										<td>{user.username}</td>
										<td>{user.email}</td>
										<td>{user.role || 'user'}</td>
										<td>
											<Button
												variant='outline-primary'
												size='sm'
												onClick={() => handleMakeAdmin(user._id)}
												disabled={user.role === 'admin'}
											>
												Make Admin
											</Button>
											<Button
												variant='outline-danger'
												size='sm'
												className='ms-2'
												onClick={() => handleDeleteUser(user._id)}
											>
												Delete
											</Button>
											{user.email?.split('@')[1] !== 'gmail.com' && (
												<Button
													className='ms-2'
													size='sm'
													variant='dark'
													onClick={() => handleResetPassword(user._id)}
												>
													Reset Password
												</Button>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Card.Body>
				</Card>
			</Container>
		</AdminLayout>
	);
};

export default AdminUser;
